import { formatFullTextDay, formatTime } from '@coolblue-development/next-formatting-utils/core';
import { TODAYS_OPEN_STATUS } from '../../enums/index.js';
import { isTomorrow } from '../../utils/isTomorrow/isTomorrow.js';
/**
 * function: formatStoreOpeningHours
 * Pattern: EEEE
 * Example: Open now, until 20:00
 */
export function formatStoreOpeningHours({ times: { today, nextOpenDay, isNewStoreThatWillOpenSoon, todaysOpenStatus }, t, language, subsidiary, timeTravelOverride, }) {
    if (isNewStoreThatWillOpenSoon) {
        return {
            isOpen: false,
            text: t('openSoon'),
        };
    }
    if (today && todaysOpenStatus === TODAYS_OPEN_STATUS.OPENING_LATER) {
        const formattedOpenTime = formatTime({ date: today.openTime, language, subsidiary });
        return {
            isOpen: false,
            text: t('opensToday', { openTime: formattedOpenTime }),
        };
    }
    if (today && todaysOpenStatus === TODAYS_OPEN_STATUS.OPEN_NOW) {
        const formattedCloseTime = formatTime({ date: today.closeTime, language, subsidiary });
        return {
            isOpen: true,
            text: t('nowOpenUntil', { closeTime: formattedCloseTime }),
        };
    }
    if ((!today || todaysOpenStatus === TODAYS_OPEN_STATUS.WAS_OPEN) && nextOpenDay) {
        const formattedNextOpenTime = formatTime({
            date: nextOpenDay.openTime,
            language,
            subsidiary,
        });
        const weekday = formatFullTextDay({ date: new Date(nextOpenDay.date), language, subsidiary });
        return {
            isOpen: false,
            text: isTomorrow(nextOpenDay.openTime, timeTravelOverride)
                ? t('opensTomorrow', { openTime: formattedNextOpenTime })
                : t('opensOn', { weekday, openTime: formattedNextOpenTime }),
        };
    }
    return {
        isOpen: false,
        text: t('closed'),
    };
}
//# sourceMappingURL=formatStoreOpeningHours.js.map